<template>
  <div>
    <div class="columns">
      <div class="column is-3"><h1 class="title">Habilitacion</h1></div>
      <div class="column">
        <div class="field is-grouped is-grouped-multiline">
          <div class="control">
            <div class="field has-addons">
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder="Comenzar en"
                  v-model="init"
                />
              </div>
              <div class="control">
                <a class="button is-info" @click="reset"> Resetear </a>
              </div>
            </div>
          </div>
          <div class="control">
            <div class="select">
              <select
                name="country"
                v-model="opciones.documento"
                @change="selectdocument"
              >
                <option
                  v-for="option in comprobanteNC"
                  :value="option._id"
                  v-bind:key="option._id"
                >
                  {{ option.codigo }} {{ option.nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>Documento</th>
          <th>Status</th>
          <th>Estado</th>
          <th>Mensaje</th>
          <th>Detalle</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(fra, index) in fras" :key="index">
          <td>
            <div class="field is-grouped">
              <p class="control">
                <strong>{{ fra.prefijo }}{{ fra.documento }}</strong>
                <small>{{
                  fra.idnit ? fra.idnit.nombre : fra.comprobanteid.titulo
                }}</small>
              </p>
              <p class="control" v-if="fra.tipo === '91' || fra.tipo === '92'">
                <input
                  class="input is-small"
                  type="text"
                  placeholder="Documento"
                  v-model="fra.documento"
                />
              </p>
            </div>
          </td>
          <td>
            <span v-show="fra.status === 'Por Enviar'" class="tag is-light"
              >Pendiente</span
            >
            <span v-show="fra.status !== 'Por Enviar'">
              <span v-show="!fra.iserror" class="tag is-primary">Ok</span>
              <span v-show="fra.iserror" class="tag is-danger">Error</span>
            </span>
          </td>
          <td>
            {{ fra.status }}
          </td>
          <td>
            <small v-if="fra.consultado">{{
              fra.response.statusDescription
                ? fra.response.statusDescription
                : fra.response.errorMessage
            }}</small>
            <small v-if="!fra.consultado">{{
              fra.iserror
                ? "Documento con error"
                : "Documento enviado con éxito"
            }}</small>
            <small v-if="fra.consultado">
              <span v-show="viewDetalle(index)">
                <br />
                <span>{{
                  fra.response.statusMessage
                    ? fra.response.statusMessage
                    : fra.response.errorMessage
                }}</span>
                <span v-if="fra.response.errorMessage"
                  ><br />
                  <span class="fontMono"
                    >{{ fra.response.errorReason }} <br />
                  </span>
                </span>
              </span>
            </small>
          </td>
          <td>
            <button class="button is-small is-info" @click="vDetalle(index)">
              <span class="material-icons"> remove_red_eye </span>
            </button>
            <button class="button is-dark is-small" @click="reenviar(fra)">
              Enviar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      init: 1,
      fras: [],
      vdet: null,
      comprobanteNC: [],
      opciones: {
        documento: null,
      },
      documentselected: {},
    };
  },
  methods: {
    selectdocument() {
      const _this = this;
      for (let index in this.comprobanteNC) {
        const comp = _this.comprobanteNC[index];
        if (_this.opciones.documento === comp._id) {
          _this.documentselected = comp;
        }
      }
    },
    async traeComprobantes() {
      const _this = this;
      let result;
      try {
        result = await apiServices.get(`/comprobantes`);
        this.comprobanteNC = [];
        result.data.forEach((el) => {
          if (el.isElectronico) {
            // que aparezcan solo los tipo factura.
            _this.comprobanteNC.push(el);
          }
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los comprobantes.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los comprobantes", err);
      }
    },
    async reset() {
      try {
        if (!this.documentselected._id) {
          this.$store.dispatch("notify", {
            message: "Primero debe seleccionar un documento",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        const result = await apiServices.post(`/resetfraelecthab`, {
          documento: this.documentselected,
          init: this.init,
        });
        if (result.data) {
          this.searchFras();
          console.log(result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    viewDetalle(index) {
      if (this.vdet === index) {
        return true;
      } else {
        return false;
      }
    },
    async searchFras() {
      try {
        const result = await apiServices.post(`/searchfraelecthab`);
        if (result.data) {
          this.fras = result.data.data.map(function (k) {
            if (!k.response) {
              k.response = {
                message: {
                  errorMessage: "N/P",
                },
                data: {
                  statusDescription: "N/P",
                },
              };
              k.detalle = ["N/P"];
            } else {
              if (k.response.message) {
                if (Array.isArray(k.response.message.errorReason)) {
                  k.detalle = k.response.message.errorReason;
                } else {
                  k.detalle = [k.response.message.errorReason];
                }
              } else if (k.response.data) {
                if (Array.isArray(k.response.data.warnings)) {
                  k.detalle = k.response.data.warnings;
                } else {
                  k.detalle = [k.response.data.warnings];
                }
              } else {
                k.detalle = ["N/P"];
              }
            }
            return k;
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    vDetalle(index) {
      if (this.vdet === index) {
        this.vdet = null;
      } else {
        this.vdet = index;
      }
    },
    async reenviar(item) {
      try {
        if (!this.documentselected._id) {
          this.$store.dispatch("notify", {
            message: "Primero debe seleccionar un documento",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        await apiServices.post(`/reenviaelectronicahab`, {
          documento: this.documentselected,
          fraelect: item,
        });
        this.searchFras();
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.searchFras();
    this.traeComprobantes();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/habilitacion/Habilitacion.vue